<template>
  <page>
    <b-row>
      <b-col cols="12" md="10" offset-md="1">
        <b-card class="shadow mx-md-10 px-1 px-md-10 py-2">
          <div class="mb-3 text-center">
            <h3>Training Video</h3>
          </div>

          <b-row class="px-1">
            <video-player class="mb-3 ml-3 mr-3 onboarding-video" :options="videoOptions" height="65vh"/>
          </b-row>

          <b-row class="px-1 pt-3 border-top">
            <b-col class="d-flex justify-content-center">
              <template v-if="!customHelpUrl">
                <b-button v-if="isRecruiter" :href="helpURLs['Recruiter-FAQs']" target="_blank" variant="link">
                  Recruiter FAQs
                </b-button>
                <b-button :href="helpURLs['Employee-FAQs']" target="_blank" variant="link">
                  <template v-if="isRecruiter">Employee FAQs</template>
                  <template v-else>Frequently Asked Questions</template>
                </b-button>
              </template>
              <b-button v-if="customHelpUrl" :href="customHelpUrl" target="_blank" variant="link">Help</b-button>
              <b-button href="https://support.reallinks.io/hc" variant="link">Support Centre</b-button>
            </b-col>
          </b-row>

        </b-card>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import Page from '@/components/Page';
import VideoPlayer from '@/components/misc/video-player';
import helpURLs from '@/assets/helpURLs';
import { mapRoot } from '@src/mixins/root';

export default {
  components: {
    Page,
    VideoPlayer,
  },
  metaInfo: {
    title: 'Training Video',
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isRecruiter' ]),
    customHelpUrl() {
      const { company } = this;
      const { siteBranding: { helpURL } = {} } = company || {};
      return helpURL && helpURL.fileLocation;
    },
    helpURLs: () => helpURLs,
    videoOptions() {
      const { sitePreferences: { trainingVideoUrl } = {} } = this.company || {};

      const options = {
        autoplay: false,
        preload: 'auto',
        controls: true,
        sources: [],
      };

      if (trainingVideoUrl) {
        options.sources.push({
          type: 'video/mp4',
          src: trainingVideoUrl,
        });
      } else {
        options.sources.push({
          type: 'video/mp4',
          src: 'https://real-links-assets.s3.eu-west-2.amazonaws.com/site-assets/video/TrainingVideo.mp4',
        });
      }

      console.log('COMPANY: ', this.company);

      if (this.company && this.company.siteBranding && this.company.siteBranding.bigLogo) {
        options.poster = this.company.siteBranding.bigLogo.fileLocation;
      }

      return options;
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-video {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/static/help/training.vue